<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn color="error" depressed v-on="on" text>Remove</v-btn>
    </template>
    <v-card class="pa-6" color="pop_bg">
      <v-card-text class="subtitle-1 mb-0 mt-6 text-center dark--text">Do you really want to delete this report?</v-card-text>

      <v-card-text v-if="error" class="error--text font-weight-bold">{{ error }}</v-card-text>
      <v-card-actions justify="center">
        <v-row justify="center">
          <v-btn color=" mx-2 error" depressed @click="close">No</v-btn>
          <v-btn color=" mx-2 success" depressed :loading="button_loading" @click="deleteReport">Yes</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    report: {
      required: true,
    },
  },
  data() {
    return {
      valid: true,
      dialog: false,
      button_loading: false,
      show_alert: false,
      error: null,
    };
  },
  methods: {
    deleteReport() {
      this.$apollo
        .mutate({
          mutation: require("../api/removeSetmenuReport.graphql"),
          variables: {
            id: this.report._id,
          },
        })
        .then(() => {
          this.button_loading = false;
          this.$root.$emit("updateSetmenuList");
          this.error = null;
          this.dialog = false;
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.button_loading = false;
        });
    },
    close() {
      this.error = null;
      this.dialog = false;
    },
  },
};
</script>
